import React from 'react';
import { useI18n } from '../../i18n';
import './GuardianWhisperBubble.css'; // Reusing standard glassmorphism styles

export default function GuardianVignette({ onContinue, message, buttonText }) {
  const { t } = useI18n();
  const displayMessage = message || t('guardian.vignetteDefaultMessage');
  const displayButtonText = buttonText || t('guardian.vignetteDefaultButton');

  // UI Safety: Explicitly overriding inherited whisper-bubble animations and flex-end positioning for the tutorial layout.
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999, // On top of everything to block interaction
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: '8vh',
        pointerEvents: 'auto', // Changed to auto to intercept clicks outside
        backgroundColor: 'rgba(0, 0, 0, 0.4)' // Add a subtle dark background to imply modal
      }}
      onClick={onContinue}
    >
      <div
        className="guardian-whisper-bubble"
        onClick={(e) => e.stopPropagation()}
        style={{
          pointerEvents: 'auto',
          maxWidth: '80%',
          width: '600px',
          position: 'relative',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          bottom: 'auto',
          top: 'auto',
          transform: 'none',
          animation: "none",
          opacity: "1",
          visibility: "visible"
        }}
      >
        <button
          onClick={onContinue}
          style={{
            position: 'absolute',
            top: '8px',
            right: '12px',
            cursor: 'pointer',
            background: 'transparent',
            border: 'none',
            color: 'var(--text-color, #fff)',
            opacity: 0.7,
            fontSize: '16px'
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <div style={{ fontSize: '1.2rem', textAlign: 'center', lineHeight: '1.5' }}>
          {displayMessage}
        </div>
        <button
          className="auth-cyber-btn"
          style={{ alignSelf: 'center', padding: '10px 24px' }}
          onClick={onContinue}
        >
          {displayButtonText}
        </button>
      </div>
    </div>
  );
}
